// Usar require.context para cargar todos los archivos JSON automáticamente
const context = require.context('./', false, /\.json$/);

// Mapeo de nombres de archivo a nombres para mostrar (en orden alfabético)
const nombrePaises = {
    'AntiguaBarbuda': 'Antigua y Barbuda',
    'Argentina': 'Argentina',
    'Bahamas': 'Bahamas',
    'Barbados': 'Barbados',
    'Belice': 'Belice',
    'Bolivia': 'Bolivia',
    'Brasil': 'Brasil',
    'Canada': 'Canadá',
    'Chile': 'Chile',
    'Colombia': 'Colombia',
    'CostaRica': 'Costa Rica',
    'Cuba': 'Cuba',
    'Dominica': 'Dominica',
    'Ecuador': 'Ecuador',
    'ElSalvador': 'El Salvador',
    'EstadosUnidos': 'Estados Unidos',
    'Granada': 'Granada',
    'Guatemala': 'Guatemala',
    'Guyana': 'Guyana',
    'Haiti': 'Haití',
    'Honduras': 'Honduras',
    'Jamaica': 'Jamaica',
    'Mexico': 'México',
    'Nicaragua': 'Nicaragua',
    'Panama': 'Panamá',
    'Paraguay': 'Paraguay',
    'Peru': 'Perú',
    'RepublicaDominicana': 'República Dominicana',
    'SanCristobalNieves': 'San Cristóbal y Nieves',
    'SantaLucia': 'Santa Lucía',
    'SanVicenteGranadinas': 'San Vicente y las Granadinas',
    'Surinam': 'Surinam',
    'TrinidadTobago': 'Trinidad y Tobago',
    'Uruguay': 'Uruguay',
    'Venezuela': 'Venezuela'
};

const paises = {};
const paisesOrdenados = [];

context.keys().forEach((path) => {
    // Extraer el nombre del archivo sin la extensión
    const fileName = path.replace('./', '').replace('.json', '');

    // Usar el nombre mapeado o formatear automáticamente
    const nombreParaMostrar = nombrePaises[fileName] ||
        fileName.replace(/([A-Z])/g, ' $1').replace(/^ /, '').trim();

    paises[nombreParaMostrar] = context(path);
    paisesOrdenados.push(nombreParaMostrar);
});

// Ordenar alfabéticamente
paisesOrdenados.sort();

export default paises;
export { paisesOrdenados };